import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AnalyticsService';
import { EventRepository } from '~repositories/EventRepository';
import { Event } from '~entities/Event';
import { IAccountSidebarBaseData } from '~interfaces/IAnalytics';

export class AccountNonLoyaltyEnrollmentSignupUseCase {
    private eventRepository: EventRepository;
    private accountNonLoyaltyEnrollmentData: IAccountSidebarBaseData;

    constructor(accountNonLoyaltyEnrollmentData: IAccountSidebarBaseData) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.accountNonLoyaltyEnrollmentData = accountNonLoyaltyEnrollmentData;
    }

    public execute() {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: this.accountNonLoyaltyEnrollmentData.eventAction,
            type: 'link',
            payload: this.getAccountNonLoyaltyEnrollmentSignupPayload()
        });
        this.eventRepository.addEventToQueue(newEvent);
    }

    private getAccountNonLoyaltyEnrollmentSignupPayload() {
        const { eventAction } = this.accountNonLoyaltyEnrollmentData;

        return {
            site_type: 'event_based',
            event_name: 'my account page',
            event_category: 'my account page',
            event_action: eventAction,
            event_label: 'banner display | [‘account sign up overlay’]',
            imp_promo_pos: ['module'],
            imp_promo_creative: ['overlay/signup'],
            imp_promo_name: ['account sign up overlay'],
            imp_promo_id: ['module-overlay/signup-account sign up overlay']
        };
    }
}
